




























import { Component, Vue, Prop } from 'vue-property-decorator';

import { RecipeIngredient } from '@/api';

@Component({
  components: {},
})
export default class ScenarioTesterRecipeIngredient extends Vue {
  @Prop({ required: true }) readonly allergenId: string;

  @Prop({ required: true }) readonly recipeIngredient: RecipeIngredient;

  @Prop({ default: false }) readonly dirty: boolean;

  get crosscontact() {
    return this.recipeIngredient.ingredient.crosscontacts.find(
      crosscontact => crosscontact.allergen.id === this.allergenId,
    );
  }
}
